import { HighlightStyle } from '@codemirror/language';
import { EditorView } from '@codemirror/view';
import { tags as t } from '@lezer/highlight';

const colors = {
  gold: '#E08700',
  teal: '#009C9C',
  rose: '#C35B54',
  muted: 'var(--grey-50)',
  purple: 'var(--primary)',
  text: 'var(--grey-90)',
};

export const editorTheme = EditorView.theme(
  {
    '&': {
      color: colors.text,
      background: 'var(--grey-10)',
    },
    '.cm-activeLine': {
      background: 'var(--grey-20)',
    },
    '.cm-activeLineGutter': {
      background: 'var(--grey-20)',
    },
    '.cm-gutters': {
      background: 'var(--grey-10)',
      color: 'var(--grey-50)',
    },
    '&.cm-editor .cm-scroller': {
      fontFamily: 'var(--font-family-monospace)',
    },
    '&.cm-focused .cm-selectionBackground, & .cm-line::selection, & .cm-selectionLayer .cm-selectionBackground, .cm-content ::selection':
      {
        background: 'var(--primary-40)',
      },
  },
  { dark: false }
);

export const syntaxTheme = HighlightStyle.define([
  { tag: t.comment, color: colors.muted },
  { tag: t.variableName, color: colors.teal },
  { tag: t.propertyName, color: colors.text },
  { tag: t.deleted, color: colors.rose },
  { tag: t.brace, color: colors.muted },
  { tag: t.string, color: colors.gold },
  { tag: t.bool, color: 'var(--primary)' },
  { tag: t.number, color: 'var(--primary)' },
  { tag: t.operator, color: colors.muted },
  { tag: t.punctuation, color: colors.muted },
  { tag: t.keyword, color: 'var(--primary)' },
]);
